import { usePoll } from "@/hooks/usePoll";
import { get } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const LV = { critical: "bg-rose-500", warning: "bg-amber-500", info: "bg-cyan-500" };

export const AlertsPanel = () => {
  const { data } = usePoll(() => get("/alerts", { limit: 15 }), 8000, []);
  return (
    <section data-testid="alerts-panel" className="rounded-md border border-slate-800 bg-[#111827] p-3">
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">Service events</h4>
      <div className="scroll-thin max-h-72 space-y-2 overflow-y-auto pr-1">
        {(data?.alerts || []).map((a, i) => (
          <div key={`${a.ts}-${i}`} data-testid={`alert-item-${i}`} className="flex gap-2">
            <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${LV[a.level] || "bg-slate-500"}`} />
            <div className="min-w-0">
              <div className="text-xs text-slate-300">{a.message}</div>
              <div className="font-mono text-[10px] text-slate-600">{a.kind} · {fmtDateTime(a.ts)}</div>
            </div>
          </div>
        ))}
        {data && data.alerts.length === 0 && <div className="py-3 text-center text-[11px] text-slate-600">No events yet</div>}
      </div>
    </section>
  );
};
